/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const MaxLinesSettingParser = /* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('MAX_LINES')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class MaxLinesSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return MaxLinesSettingParser.decode(input).map(res => new MaxLinesSetting(res));
    }
    static unsafeDecode(input) {
        return MaxLinesSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return MaxLinesSettingParser.encode(data);
    }
    static schema() {
        return MaxLinesSettingParser.schema();
    }
}
